import { ofType } from "redux-observable";
import { mergeMap, map, catchError } from "rxjs/operators";
import { of } from "rxjs";
import {
  actionTypes,
  changeFirstPasswordFailure,
  changeFirstPasswordSuccess,
  generateLoginOtpRequestFailure,
  generateLoginOtpRequestSuccess,
  getDomainsFailure,
  getDomainsSuccess,
  getPasswordPolicyFailure,
  getPasswordPolicySuccess,
  getQuestionsLoginFailure,
  getQuestionsLoginSuccess,
  postLoginAnswerFailure,
  postLoginAnswerSuccess,
  postOTPFailure,
  postOTPSuccess,
  postPasswordFailure,
  postPasswordSuccess,
} from "./actions";
import {
  changeFirstPasswordService,
  fetchDomains,
  fetchPasswordPolicy,
  generateOTP,
  postLoginAnswer,
  postLoginOtp,
  postPassword,
} from "./services";
import { fetchSecurityQuestionsLogin } from "../../ProfileManagement/module/services";

const fetchGetDomainsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_DOMAINS),
    mergeMap((action: any) =>
      fetchDomains().pipe(
        map((response: any) => getDomainsSuccess(response)),
        catchError((error: any) => of(getDomainsFailure(error)))
      )
    )
  );

const fetchGetQuestionsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_QUESTIONS_LOGIN),
    mergeMap((action: any) =>
      fetchSecurityQuestionsLogin(action.payload).pipe(
        map((response: any) => getQuestionsLoginSuccess(response)),
        catchError((error: any) => of(getQuestionsLoginFailure(error)))
      )
    )
  );

const postLoginAnswerEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.POST_LOGIN_ANSWER),
    mergeMap((action: any) =>
      postLoginAnswer(action.payload).pipe(
        map((response: any) => postLoginAnswerSuccess(response)),
        catchError((error: any) => of(postLoginAnswerFailure(error)))
      )
    )
  );

const postLoginOtpEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.POST_LOGIN_OTP),
    mergeMap((action: any) =>
      postLoginOtp(action.payload).pipe(
        map((response: any) => postOTPSuccess(response)),
        catchError((error: any) => of(postOTPFailure(error)))
      )
    )
  );

const postPasswordPolicyEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_PASSWORD_POLICY),
    mergeMap(() =>
      fetchPasswordPolicy().pipe(
        map((response: any) => getPasswordPolicySuccess(response)),
        catchError((error: any) => of(getPasswordPolicyFailure(error)))
      )
    )
  );

const postPasswordEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.POST_PASSWORD),
    mergeMap((action: any) =>
      postPassword(action.payload.token, action.payload.data).pipe(
        map((response: any) => postPasswordSuccess()),
        catchError((error: any) => of(postPasswordFailure(error)))
      )
    )
  );

const GenerateLoginOTPEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GENERATE_LOGIN_OTP),
    mergeMap((action: any) =>
      generateOTP(action.payload).pipe(
        map((response: any) => generateLoginOtpRequestSuccess(response)),
        catchError((error: any) => of(generateLoginOtpRequestFailure(error)))
      )
    )
  );

const changeFirstPwdEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.CHANGE_FIRST_PWD),
    mergeMap((action: any) =>
      changeFirstPasswordService(action.payload).pipe(
        map((response: any) => changeFirstPasswordSuccess()),
        catchError((error: any) => of(changeFirstPasswordFailure(error)))
      )
    )
  );

export default [
  fetchGetDomainsEpic,
  fetchGetQuestionsEpic,
  postLoginAnswerEpic,
  postLoginOtpEpic,
  postPasswordPolicyEpic,
  postPasswordEpic,
  GenerateLoginOTPEpic,
  changeFirstPwdEpic,
];
